function getReturnValue(value: number, f: (n: number) => number): number {
  if (!f) return value;
  return f(value);
}

export function getDaysLeft(date, roundingMethod = Math.floor) {
  const dateToday = Date.now();
  const targetDate = new Date(date).getTime();
  const distanceToDate = targetDate - dateToday;
  return Math.max(
    0,
    getReturnValue(distanceToDate / 1000 / 60 / 60 / 24, roundingMethod)
  );
}

export function getHoursLeft(date, roundingMethod = Math.floor) {
  const dateToday = Date.now();
  const targetDate = new Date(date).getTime();
  const distanceToDate = targetDate - dateToday;
  return Math.max(
    0,
    getReturnValue((distanceToDate / 1000 / 60 / 60) % 24, roundingMethod)
  );
}

export function getMinutesLeft(date, roundingMethod = Math.floor) {
  const dateToday = Date.now();
  const targetDate = new Date(date).getTime();
  const distanceToDate = targetDate - dateToday;
  return Math.max(
    0,
    getReturnValue((distanceToDate / 1000 / 60) % 60, roundingMethod)
  );
}

export function getSecondsLeft(date, roundingMethod = Math.floor) {
  const dateToday = Date.now();
  const targetDate = new Date(date).getTime();
  const distanceToDate = targetDate - dateToday;
  return Math.max(
    0,
    getReturnValue((distanceToDate / 1000) % 60, roundingMethod)
  );
}

export default function getTimeLeft(
  endDate: string | Date,
  startDate: string | Date = new Date()
): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} {
  const startTimestamp = new Date(startDate).getTime();
  const targetTimestamp = new Date(endDate).getTime();

  const distanceToDate = targetTimestamp - startTimestamp;
  const days = Math.max(0, Math.floor(distanceToDate / 1000 / 60 / 60 / 24));
  const hours = Math.max(0, Math.floor((distanceToDate / 1000 / 60 / 60) % 24));
  const minutes = Math.max(0, Math.floor((distanceToDate / 1000 / 60) % 60));

  const seconds = Math.max(0, Math.floor((distanceToDate / 1000) % 60));

  return { days, hours, minutes, seconds };
}
